export const environment = {
  production: false,
  uat: true,
  api: 'https://uat.groovesdentaldesign.com/api/',
  defaultPageSizeOnScroll: 10,
  defaultPageSizeOnLoad: 10,
  defaultPageIndexOnLoad: 0,
};
  